import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/identities/$id')({
  beforeLoad: () => getTitleContextSlice('Identities'),
});
